import { useEffect } from "react";

export default function Impressum() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://app.termly.io/embed-policy.min.js";
    script.id = "termly-jssdk";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="terms-container">
      <div
        name="termly-embed"
        data-id="53fcea0e-bf18-4f6a-b333-cdc81924dea8"
      ></div>
    </div>
  );
}
